export default __webpack_public_path__ + "static/media/gov-white.c040530b.svg";